<script setup>
const { $isMobile } = useNuxtApp();

definePageMeta({
	"m-showNavBar": true,
	"m-showFooter": true,
	"m-showFixedHeader": true,
	"m-isSticky": true,
	"pc-showFixedHeader": true,
	"pc-showNavBar": true,
	"pc-showFooter": true,
	breadcrumbName: "common.breadcrumb.tutor",
});

useHead({
	title: "全球200+專家為你提供專業服務",
	meta: [
		{ name: "keywords", content: "八字测试，真人八字测试" },
		{
			name: "description",
			content:
				"先知命局，專業真人八字测试平台，為您提供權威、精準的测试服務。無論是八字命理分析、事業財運預測，還是感情婚姻指導，均由資深命理師在線一對一解讀。",
		},
	],
});

// 动态导入组件（代码分割）
const DynamicComponent = $isMobile
	? defineAsyncComponent(() => import("@variants/seer/master-fortune/m/index.vue"))
	: defineAsyncComponent(() => import("@variants/seer/master-fortune/pc/index.vue"));
</script>

<template>
	<DynamicComponent />
</template>
